webpackJsonp([35],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/*!*********************************!*\
  !*** ./client/plugins/axios.js ***!
  \*********************************/
/*! exports provided: setToken, hasToken, needsAuthentication, default, localAxios */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setToken */
/* unused harmony export hasToken */
/* unused harmony export needsAuthentication */
/* unused harmony export localAxios */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(/*! axios */ 82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var WebsiteCreateModuleShopConfig = window.WebsiteCreateModuleShopConfig || {};

/*
 * Default parameters which are added to each request
 */
var axiosParams = {};

// If we are in development mode, we add the xDebug Header to each request
if (false) {
  axiosParams = {
    XDEBUG_SESSION_START: 'PHPSTORM'
  };
}

var axios = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: WebsiteCreateModuleShopConfig.apiEndpoint,
  timeout: 40000,
  params: axiosParams
});

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.request.use(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(config) {
    var authHeader;
    return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(needsAuthentication() && !hasToken())) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return setToken();

          case 3:
            authHeader = _context.sent;

            config.headers['Authorization'] = authHeader;

          case 5:
            return _context.abrupt('return', config);

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  return Promise.reject(error);
});

// ----------------------------------------
// Vue Plugin
// ----------------------------------------
var VueAxios = {
  install: function install(Vue) {
    // Globally register as $http
    Vue.prototype.$http = axios;
  }

  // ----------------------------------------
  // Install vue plugin
  // ----------------------------------------
};__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(VueAxios);

// ----------------------------------------
// setToken helper
// ----------------------------------------
var setToken = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var _ref3, data, authHeader;

    return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return localAxios.post('/oauth', {
              grant_type: 'client_credentials',
              client_id: WebsiteCreateModuleShopConfig.auth.clientId,
              client_secret: WebsiteCreateModuleShopConfig.auth.clientSecret
            });

          case 2:
            _ref3 = _context2.sent;
            data = _ref3.data;

            if (data) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt('return', false);

          case 6:
            authHeader = data.token_type + ' ' + data.access_token;


            axios.defaults.headers.common['Authorization'] = authHeader;

            return _context2.abrupt('return', authHeader);

          case 9:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function setToken() {
    return _ref2.apply(this, arguments);
  };
}();
var hasToken = function hasToken() {
  return !!axios.defaults.headers.common['Authorization'];
};
var needsAuthentication = function needsAuthentication() {
  return !!WebsiteCreateModuleShopConfig.auth;
};

/**
 * With all the defaults for axios set, we can export it as a module.
 */
/* harmony default export */ __webpack_exports__["a"] = (axios);

/*
 * Create a local instance where the baseURL points to the backend
 */
var localAxios = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: WebsiteCreateModuleShopConfig.baseURL,
  timeout: 20000
});

/***/ }),
/* 6 */
/*!*******************************!*\
  !*** ./client/store/index.js ***!
  \*******************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_cartStorage__ = __webpack_require__(/*! ./plugins/cartStorage */ 17);
/*
 * This is the entry point for the store.
 * Create a new module for your store object
 */




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var files = __webpack_require__(/*! ./ */ 80);
var filenames = files.keys();

function getModule(filename) {
  var file = files(filename);
  return file.default ? file.default : file;
}

function getModuleNamespace(storeData, namePath) {
  if (namePath.length === 1) return storeData.modules;

  var namespace = namePath.shift();

  storeData.modules[namespace] = storeData.modules[namespace] || {};
  storeData.modules[namespace].namespaced = true;
  storeData.modules[namespace].modules = storeData.modules[namespace].modules || {};

  return getModuleNamespace(storeData.modules[namespace], namePath);
}

var store = void 0;
var storeData = {};

// Generate the store from all the modules inside the store folder
storeData.modules = storeData.modules || {};
var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = filenames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var filename = _step.value;

    var name = filename.replace(/^\.\//, '').replace(/\.js$/, '');
    if (name === 'index') continue;

    var namePath = name.split(/\//);
    var module = getModuleNamespace(storeData, namePath);

    name = namePath.pop();
    module[name] = getModule(filename);
    module[name].namespaced = true;
  }

  // Plugins
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

storeData.plugins = storeData.plugins || [];
storeData.plugins.push(Object(__WEBPACK_IMPORTED_MODULE_2__plugins_cartStorage__["default"])());

store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store(storeData);

/* harmony default export */ __webpack_exports__["default"] = (store);

/***/ }),
/* 7 */,
/* 8 */
/*!**********************************!*\
  !*** ./client/router/_helper.js ***!
  \**********************************/
/*! exports provided: componentsHelper */
/*! exports used: componentsHelper */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentsHelper; });
var componentsHelper = function componentsHelper(path) {
  return {
    name: path,
    components: {
      desktop: function desktop() {
        return __webpack_require__(/*! ../views/desktop */ 112)("./" + path);
      },
      mobile: function mobile() {
        return __webpack_require__(/*! ../views/mobile */ 115)("./" + path);
      }
    }
  };
};

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/*!*********************************************!*\
  !*** ./client/store/plugins/cartStorage.js ***!
  \*********************************************/
/*! exports provided: default, initializeCart */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = cartStorage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initializeCart", function() { return initializeCart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage__ = __webpack_require__(/*! localforage */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_localforage__);


var _this2 = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var localstorageCartKey = 'v1_shop_cart';
var isInternalUpdate = false;

var updateStoreFromStrorage = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(store) {
    var storeCartState;
    return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.getItem(localstorageCartKey);

          case 2:
            storeCartState = _context.sent;


            store.commit('cart/initialize');

            if (!(!storeCartState || storeCartState.expires < new Date())) {
              _context.next = 7;
              break;
            }

            // if there is no cart saved in storage, or the saved state is expired,
            // clear the cart
            store.commit('cart/clear');
            return _context.abrupt('return');

          case 7:

            isInternalUpdate = true;
            _context.next = 10;
            return store.dispatch('cart/initialize', storeCartState.value);

          case 10:
            isInternalUpdate = false;

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function updateStoreFromStrorage(_x) {
    return _ref.apply(this, arguments);
  };
}();

function cartStorage() {
  var _this = this;

  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(store) {
      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // subscribe for changes in the store
              store.subscribe(function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(mutation, state) {
                  var storeCartState, storeExipresAt;
                  return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!isInternalUpdate) {
                            _context2.next = 2;
                            break;
                          }

                          return _context2.abrupt('return');

                        case 2:
                          if (!(!mutation.type.includes('cart') || mutation.type === 'cart/initialize')) {
                            _context2.next = 4;
                            break;
                          }

                          return _context2.abrupt('return');

                        case 4:
                          storeCartState = JSON.parse(JSON.stringify(state.cart));

                          // Storage expires in 5 days

                          storeExipresAt = new Date();

                          storeExipresAt.setDate(storeExipresAt.getDate() + 5);

                          _context2.next = 9;
                          return __WEBPACK_IMPORTED_MODULE_1_localforage___default.a.setItem(localstorageCartKey, {
                            value: storeCartState,
                            expires: storeExipresAt
                          });

                        case 9:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this);
                }));

                return function (_x3, _x4) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

// initialize the store with the state from the storage
var initializeCart = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(store) {
    return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', updateStoreFromStrorage(store));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this2);
  }));

  return function initializeCart(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/App.vue ***!
  \**********************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_plugins_cartStorage__ = __webpack_require__(/*! ./store/plugins/cartStorage */ 17);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.requestShop();
              _context.next = 3;
              return this.requestProducts();

            case 3:
              _context.next = 5;
              return Object(__WEBPACK_IMPORTED_MODULE_2__store_plugins_cartStorage__["initializeCart"])(this.$store);

            case 5:
              this.registerNavigationIEFix();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  data: function data() {
    return {
      mediaQueryDevice: 'mobile'
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    useRootContainer: 'shop/getUseRootContainer',
    isMobile: 'shop/getMetaIsMobile'
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 0;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;

        _this.mediaQueryDevice = isMobile ? 'mobile' : 'desktop';
        _this.setMetaIsMobile(isMobile);
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
    handler();

    this.setMetaIsEditor(this.inIframe());
  },

  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
    setMetaIsMobile: 'shop/setMetaIsMobile',
    setMetaIsEditor: 'shop/setMetaIsEditor'
  }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    requestShop: 'shop/request',
    requestProducts: 'products/request'
  }), {
    inIframe: function inIframe() {
      // test if we are inside a frame / in the editor
      // since window.top might not be defined or blocked due to same-origin policy,
      // we need to catch errors
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    registerNavigationIEFix: function registerNavigationIEFix() {
      var _this2 = this;

      // Fix for IE, routing does not work in IE if elements are outside of vue application.
      // So we need to add an event to each link and trigger navigation manually
      var elements = document.getElementsByClassName('navigationElement shop');
      Array.prototype.forEach.call(elements, function (el) {
        var nodes = el.getElementsByTagName('A');
        if (nodes.length) {
          Array.prototype.forEach.call(nodes, function (node) {
            node.addEventListener('click', _this2.navigate);
          });
        }
      });
    },
    navigate: function navigate(event) {
      var url = event.target.hash.replace('#', '');
      this.$router.push(url);
    }
  })
});

/***/ }),
/* 21 */
/*!********************************!*\
  !*** ./client/router/index.js ***!
  \********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__guards_beforeEach__ = __webpack_require__(/*! ./guards/beforeEach */ 78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guards_afterEach__ = __webpack_require__(/*! ./guards/afterEach */ 79);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var files = __webpack_require__(/*! ./ */ 110);
var filenames = files.keys();

function getRoutes(filename) {
  var file = files(filename);
  return file.default ? file.default : file;
}

var routes = [];
var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = filenames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var filename = _step.value;

    var name = filename.replace(/^\.\//, '').replace(/\.js$/, '');
    if (name === 'index') continue;

    var namePath = name.split(/\//);
    name = namePath.pop();
    routes.push.apply(routes, _toConsumableArray(getRoutes(filename)));
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/',
    redirect: '/products'
  }].concat(routes)
});

router.beforeEach(__WEBPACK_IMPORTED_MODULE_2__guards_beforeEach__["a" /* default */]);
router.afterEach(__WEBPACK_IMPORTED_MODULE_3__guards_afterEach__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = (router);

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/*!***************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/slider.vue ***!
  \***************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      required: false
    },
    className: {
      type: String,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    value: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    toggleChecked: function toggleChecked() {
      if (this.disabled) return;

      this.$emit('input', !this.value);
    },

    updateInput: function updateInput(event) {
      this.$emit('input', event.target.checked);
    }
  }
});

/***/ }),
/* 28 */
/*!****************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/loading.vue ***!
  \****************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      default: true
    }
  }
});

/***/ }),
/* 29 */
/*!********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/multiselect.vue ***!
  \********************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(/*! vue-multiselect */ 131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  props: ['value', 'label', 'customLabel', 'track-by', 'options', 'multiple', 'taggable', 'allow-empty', 'close-on-select', 'clear-on-select', 'disabled', 'placeholder'],
  computed: {
    placeholderText: function placeholderText() {
      if (this.value && this.value.length !== 0) return '';
      return this.placeholder || '';
    }
  },
  methods: {
    tag: function tag() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['tag'].concat(_toConsumableArray(args)));
    },
    input: function input() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['input'].concat(_toConsumableArray(args)));
    }
  }
});

/***/ }),
/* 30 */
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/singleselect.vue ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    classes: {},
    placeholder: {},
    value: {
      default: undefined
    }
  },
  computed: {},
  methods: {
    valueChanged: function valueChanged(event) {
      this.$emit('input', event.target.value);
    }
  }
});

/***/ }),
/* 31 */
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/productPanel.vue ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 9);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isDetail: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])({
    shop: 'shop/get',
    isMobile: 'shop/getMetaIsMobile'
  }), {
    usePanels: function usePanels() {
      if (this.$route.params.id) return this.usePanelsDetail;
      return this.usePanelsOverview;
    },
    usePanelsOverview: function usePanelsOverview() {
      if (this.isMobile) return this.shop.display_mobile_overview_use_panels;
      return this.shop.display_desktop_overview_use_panels;
    },
    usePanelsDetail: function usePanelsDetail() {
      if (this.isMobile) return this.shop.display_mobile_detail_use_panels;
      return this.shop.display_desktop_detail_use_panels;
    }
  })
});

/***/ }),
/* 32 */
/*!************************************!*\
  !*** ./client/plugins/vue-i18n.js ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(/*! vue-i18n */ 138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_messageformat__ = __webpack_require__(/*! messageformat */ 139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_formaters_price__ = __webpack_require__(/*! ./i18n-formaters/price */ 150);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// import moment from 'moment'


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var MessageFormatter = function () {
  function MessageFormatter(options) {
    _classCallCheck(this, MessageFormatter);

    this._locale = options.locale || 'en-US';
    this._formatter = new __WEBPACK_IMPORTED_MODULE_2_messageformat___default.a(this._locale);
    this._caches = Object.create(null);

    this._formatter.addFormatters({
      // momentAgo (value) { return moment(value).fromNow() }
      price: __WEBPACK_IMPORTED_MODULE_3__i18n_formaters_price__["a" /* default */]
    });
  }

  _createClass(MessageFormatter, [{
    key: 'interpolate',
    value: function interpolate(message, values) {
      var fn = this._caches[message];
      if (!fn) {
        fn = this._formatter.compile(message, this._locale);
        this._caches[message] = fn;
      }
      return [fn(values)];
    }
  }]);

  return MessageFormatter;
}();

var locale = 'de-DE';
var formatter = new MessageFormatter({ locale: locale });

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: locale,
  formatter: formatter,
  messages: {
    'de-DE': __webpack_require__(/*! static/locales/de-DE.json */ 151)
  }
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 33 */,
/* 34 */
/*!************************************!*\
  !*** ./client/plugins/wsc-shop.js ***!
  \************************************/
/*! exports provided: supportedCurrencies, supportedWeight, default */
/*! exports used: supportedCurrencies */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportedCurrencies; });
/* unused harmony export supportedWeight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index__ = __webpack_require__(/*! ./../store/index */ 6);



var supportedCurrencies = [{
  label: 'Schweizer Franken - CHF',
  short: 'CHF',
  value: 'chf',
  local: 'de-ch'
}, {
  label: 'Euro - EUR (€)',
  short: '€',
  value: 'eur',
  local: 'de-de'
}, {
  label: 'US-Dollar - USD ($)',
  short: '$',
  value: 'usd',
  local: 'en-us'
}, {
  label: 'Pfund Sterling - GBP (£)',
  short: '£',
  value: 'gbp',
  local: 'en-gb'
}];

var supportedWeight = [{
  label: 'Kilogramm (kg)',
  short: 'kg',
  value: 'kg'
}, {
  label: 'Gramm (g)',
  short: 'g',
  value: 'g'
}];

var emptyStub = {
  label: '',
  short: '',
  value: ''

  /*
   * Vue plugin
   */
};var MyPlugin = {
  install: function install(Vue, options) {
    Vue.prototype.$supportedCurrencies = supportedCurrencies;

    Vue.prototype.$supportedWeight = supportedWeight;

    Vue.mixin({
      computed: {
        shop: function shop() {
          return __WEBPACK_IMPORTED_MODULE_1__store_index__["default"].getters['shop/get'];
        },
        shopCurrency: function shopCurrency() {
          var _this = this;

          var shopCurrency = supportedCurrencies.find(function (option) {
            return option.value === _this.shop.currency;
          });
          if (shopCurrency === undefined) return emptyStub;
          return shopCurrency;
        },
        shopWeight: function shopWeight() {
          var _this2 = this;

          var shopWeight = supportedWeight.find(function (option) {
            return option.value === _this2.shop.weight;
          });
          if (shopWeight === undefined) return emptyStub;
          return shopWeight;
        }
      }
    });
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(MyPlugin);

/* unused harmony default export */ var _unused_webpack_default_export = (MyPlugin);

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/*!*************************!*\
  !*** ./client/index.js ***!
  \*************************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(/*! ./promise-polyfill */ 67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(/*! ./app */ 70);



// Enable progressive web app support (with offline-plugin)
if (true) {
  // PWA not jet implemented. But will be a good use case to cache images
  // remember to add it in webpack.prod.js
  // require('./pwa')
}

__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#wsc_shop_app');

/***/ }),
/* 67 */
/*!************************************!*\
  !*** ./client/promise-polyfill.js ***!
  \************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(/*! promise-polyfill */ 68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

// Polyfill for NodeList in IE11
NodeList.prototype.forEach = NodeList.prototype.forEach || Array.prototype.forEach;

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */
/*!***********************!*\
  !*** ./client/app.js ***!
  \***********************/
/*! exports provided: app, router, store */
/*! exports used: app */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(/*! vuex-router-sync */ 71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(/*! ./App */ 72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(/*! ./router */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(/*! ./store */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_plugins__ = __webpack_require__(/*! plugins */ 119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_plugins_vue_i18n__ = __webpack_require__(/*! plugins/vue-i18n */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_scss_style_scss__ = __webpack_require__(/*! ../assets/scss/style.scss */ 154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_scss_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_scss_style_scss__);
/* unused harmony reexport router */
/* unused harmony reexport store */






// Import all plugins


// vue-i18n needs to be passed to the vue Application, so we will import is here


// Global styling for the shop


Object(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["default"], __WEBPACK_IMPORTED_MODULE_3__router__["default"]);

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](Object.assign({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["default"],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["default"],
  i18n: __WEBPACK_IMPORTED_MODULE_6_plugins_vue_i18n__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]));



/***/ }),
/* 71 */,
/* 72 */
/*!************************!*\
  !*** ./client/App.vue ***!
  \************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e6e50fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6e6e50fa","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 76);
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e6e50fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e6e50fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/App.vue ***!
  \*************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
'wc_content_container_inner': _vm.useRootContainer && !_vm.isMobile,
'wc_content_container_mobile': _vm.useRootContainer && _vm.isMobile
},attrs:{"id":"wsc_shop_app"}},[_c('router-view',{attrs:{"name":_vm.mediaQueryDevice}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 77 */,
/* 78 */
/*!********************************************!*\
  !*** ./client/router/guards/beforeEach.js ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This guard checks the url on each navigation and sets the corresponding navigation item as active.
 * Since we are not making a full page reload we can not use the php render function to set the active item.
 *
 * @param to
 * @param from
 * @param next
 */
/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  var elements = document.getElementsByClassName('navigationElement');
  Array.prototype.forEach.call(elements, function (el) {
    el.classList.remove('active');
  });

  var selector = '/shop';
  if (to.name === 'cart/index') {
    selector = '/shop#/cart';
  }

  elements = document.getElementsByClassName('navigationElement shop');
  Array.prototype.forEach.call(elements, function (el) {
    var node = el.querySelectorAll('[href="' + selector + '"], [page_id="module_shop"]');
    if (node.length) {
      node[0].parentNode.classList.add('active');
    }
  });

  // in mobile view we need to close the navigation, because we do not always make a full page reload
  var mobileMenu = document.getElementsByClassName('wsc_navigation_close');
  if (mobileMenu.length) {
    mobileMenu[0].click();
  }

  // add a class to body
  document.body.classList.add('module-shop-active');

  next();
});

/***/ }),
/* 79 */
/*!*******************************************!*\
  !*** ./client/router/guards/afterEach.js ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index__ = __webpack_require__(/*! ./../../store/index */ 6);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from) {
  return __WEBPACK_IMPORTED_MODULE_0__store_index__["default"].commit('shop/setUseRootContainer', true);
});

/***/ }),
/* 80 */
/*!***********************************!*\
  !*** ./client/store ^\.\/.*\.js$ ***!
  \***********************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cart.js": 81,
	"./categories.js": 101,
	"./index.js": 6,
	"./order.js": 102,
	"./plugins/cartStorage.js": 17,
	"./products.js": 103,
	"./shop.js": 109
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;

/***/ }),
/* 81 */
/*!******************************!*\
  !*** ./client/store/cart.js ***!
  \******************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep__ = __webpack_require__(/*! lodash.clonedeep */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var state = {
  list: null,
  initialize: false,
  differentDeliveryCustomer: false,
  paymentCustomer: {},
  deliveryCustomer: {},
  shippingRegulations: null
};

var getters = {
  cart: function cart(state) {
    return state.list;
  },
  countArticles: function countArticles(state) {
    // If the cart has not been initialized return null
    if (!state.list) return null;
    return state.list.length;
  },
  cartTotalPrice: function cartTotalPrice(state, getters, rootState, rootGetters) {
    // If the cart has not been initialized return null
    if (!state.list) return null;
    // Map over all Articles and get their price
    var prices = state.list.map(function (article) {
      var product = rootGetters['products/getProductById'](article.product_id);
      // If the article is not a variation return the default price
      if (!article.variation_id) {
        if (product.use_discount_price) {
          return product.default_discount_price * article.amount;
        }
        return product.default_price * article.amount;
      }

      // otherwise return the price of the variation
      var variation = rootGetters['products/getVariationForProduct'](article.product_id, article.variation_id);
      if (!variation) return 0;
      if (product.use_discount_price) {
        return variation.discount_price * article.amount;
      }
      return variation.price * article.amount;
    });

    return prices.reduce(function (sum, price) {
      return sum + price;
    }, 0);
  },
  differentDeliveryCustomer: function differentDeliveryCustomer(state) {
    return state.differentDeliveryCustomer;
  },
  paymentCustomer: function paymentCustomer(state) {
    return state.paymentCustomer;
  },
  deliveryCustomer: function deliveryCustomer(state) {
    if (!state.differentDeliveryCustomer) {
      return state.paymentCustomer;
    }
    return state.deliveryCustomer;
  }
};

var mutations = {
  initialize: function initialize(state) {
    state.initialize = true;
  },
  add: function add(state, article) {
    if (state.initialize) {
      state.list = [];
      state.initialize = false;
    }

    var existingArticle = state.list.find(function (c) {
      return c.product_id === article.product_id && c.variation_id === article.variation_id;
    });

    if (existingArticle) {
      existingArticle.amount += article.amount;
      return existingArticle.amount;
    }

    return state.list.push({
      product_id: article.product_id,
      variation_id: article.variation_id,
      amount: article.amount
    });
  },
  update: function update(state, article) {
    state.list.splice(state.list.findIndex(function (c) {
      return c.product_id === article.product_id && c.variation_id === article.variation_id;
    }), 1, article);
  },
  remove: function remove(state, article) {
    state.list.splice(state.list.indexOf(article), 1);
  },
  clear: function clear(state) {
    state.list = [];
  },
  setDifferentDeliveryCustomer: function setDifferentDeliveryCustomer(state, differentDeliveryCustomer) {
    state.differentDeliveryCustomer = differentDeliveryCustomer;
  },
  setPaymentCustomer: function setPaymentCustomer(state, paymentCustomer) {
    state.paymentCustomer = paymentCustomer;
  },
  setDeliveryCustomer: function setDeliveryCustomer(state, deliveryCustomer) {
    state.deliveryCustomer = deliveryCustomer;
  }
};

var actions = {
  initialize: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref, value) {
      var state = _ref.state,
          dispatch = _ref.dispatch,
          commit = _ref.commit;

      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, article;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state.differentDeliveryCustomer = value.differentDeliveryCustomer;
              state.paymentCustomer = value.paymentCustomer;
              state.deliveryCustomer = value.deliveryCustomer;

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 6;
              _iterator = value.list[Symbol.iterator]();

            case 8:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 15;
                break;
              }

              article = _step.value;
              _context.next = 12;
              return dispatch('addArticle', article);

            case 12:
              _iteratorNormalCompletion = true;
              _context.next = 8;
              break;

            case 15:
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](6);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 21:
              _context.prev = 21;
              _context.prev = 22;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 24:
              _context.prev = 24;

              if (!_didIteratorError) {
                _context.next = 27;
                break;
              }

              throw _iteratorError;

            case 27:
              return _context.finish(24);

            case 28:
              return _context.finish(21);

            case 29:
              if (state.list) {
                _context.next = 32;
                break;
              }

              _context.next = 32;
              return commit('clear');

            case 32:
              return _context.abrupt('return', state);

            case 33:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[6, 17, 21, 29], [22,, 24, 28]]);
    }));

    function initialize(_x, _x2) {
      return _ref2.apply(this, arguments);
    }

    return initialize;
  }(),
  addArticle: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, article) {
      var state = _ref3.state,
          commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch('products/requestDetailed', article.product_id, { root: true });

            case 2:
              _context2.next = 4;
              return commit('add', article);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function addArticle(_x3, _x4) {
      return _ref4.apply(this, arguments);
    }

    return addArticle;
  }(),
  updateArticle: function updateArticle(_ref5, article) {
    var state = _ref5.state,
        commit = _ref5.commit;

    commit('update', article);
  },
  removeArticle: function removeArticle(_ref6, article) {
    var state = _ref6.state,
        commit = _ref6.commit;

    commit('remove', article);
  },
  getDeliveryCountries: function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref7) {
      var state = _ref7.state,
          commit = _ref7.commit,
          getters = _ref7.getters,
          rootGetters = _ref7.rootGetters;

      var _ref9, data, shippingRegulations, availableOptions;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (state.shippingRegulations) {
                _context3.next = 6;
                break;
              }

              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/shipping-regulation');

            case 3:
              _ref9 = _context3.sent;
              data = _ref9.data;

              state.shippingRegulations = data.data;

            case 6:
              shippingRegulations = state.shippingRegulations;

              // only active regulations

              shippingRegulations = shippingRegulations.filter(function (regulation) {
                return regulation.active;
              });

              // if system wide no weight - only options where the delivery_type is not "weight"
              if (!rootGetters['shop/get'].use_weight) {
                shippingRegulations = shippingRegulations.filter(function (regulation) {
                  regulation.shipping_options.data = regulation.shipping_options.data.filter(function (option) {
                    return option.delivery_type !== 'weight';
                  });
                  return regulation.shipping_options.data.length > 0;
                });
              }

              availableOptions = shippingRegulations.map(function (option) {
                return option.countries;
              }).reduce(function (a, b) {
                return a.concat(b);
              }, []);
              return _context3.abrupt('return', availableOptions);

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getDeliveryCountries(_x5) {
      return _ref8.apply(this, arguments);
    }

    return getDeliveryCountries;
  }(),
  getDeliveryOptions: function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(_ref10) {
      var state = _ref10.state,
          commit = _ref10.commit,
          getters = _ref10.getters,
          rootGetters = _ref10.rootGetters;

      var _ref12, data, deliveryCustomer, availableOptions, newvar, copy;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (state.shippingRegulations) {
                _context4.next = 6;
                break;
              }

              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/shipping-regulation');

            case 3:
              _ref12 = _context4.sent;
              data = _ref12.data;

              state.shippingRegulations = data.data;

            case 6:
              deliveryCustomer = getters.deliveryCustomer;

              // only options with the same country

              availableOptions = state.shippingRegulations.filter(function (option) {
                return option.active && option.countries.includes(deliveryCustomer.country);
              });
              newvar = availableOptions;

              // if system wide no weight - only options where the delivery_type is not "weight"

              if (!rootGetters['shop/get'].use_weight) {
                copy = __WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep___default()(availableOptions);

                newvar = copy.filter(function (regulation) {
                  regulation.shipping_options.data = regulation.shipping_options.data.filter(function (option) {
                    return option.delivery_type !== 'weight';
                  });
                  return regulation.shipping_options.data.length > 0;
                });
              }

              return _context4.abrupt('return', newvar);

            case 11:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function getDeliveryOptions(_x6) {
      return _ref11.apply(this, arguments);
    }

    return getDeliveryOptions;
  }()
};

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/*!************************************!*\
  !*** ./client/store/categories.js ***!
  \************************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 5);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var state = {
  list: []
};

var getters = {
  categories: function categories(state) {
    return state.list;
  },
  countCategories: function countCategories(state) {
    return state.list.length;
  },

  getCategoryById: function getCategoryById(state, getters) {
    return function (id) {
      if (state.list.length === 0) return null;
      return state.list.find(function (category) {
        return category.id === id;
      });
    };
  }
};

var mutations = {
  add: function add(state, category) {
    var oldCategory = state.list.find(function (c) {
      return c.id === category.id;
    });

    if (oldCategory) {
      return state.list.splice(state.list.indexOf(oldCategory), 1, category);
    }

    return state.list.push(category);
  }
};

var actions = {
  request: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref, forceRequest) {
      var state = _ref.state,
          commit = _ref.commit;

      var _ref3, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!forceRequest && state.list.length)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/category?include=products');

            case 4:
              _ref3 = _context.sent;
              data = _ref3.data;

              data.data.forEach(function (category) {
                return commit('add', category);
              });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function request(_x, _x2) {
      return _ref2.apply(this, arguments);
    }

    return request;
  }()
};

/***/ }),
/* 102 */
/*!*******************************!*\
  !*** ./client/store/order.js ***!
  \*******************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 5);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var state = {
  order: null
};

var getters = {
  order: function order(state) {
    return state.order;
  }
};

var mutations = {
  set: function set(state, order) {
    state.order = order;
  },
  clearOrder: function clearOrder(state) {
    state.order = null;
  }
};

var actions = {
  create: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref, order) {
      var state = _ref.state,
          commit = _ref.commit,
          getters = _ref.getters;
      var response;
      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (getters.order) {
                order = Object.assign({}, getters.order, order);
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].post('/order?include=products,payment,shippingOption', order);

            case 3:
              response = _context.sent;
              _context.next = 6;
              return commit('set', response.data.data);

            case 6:
              return _context.abrupt('return', response.data.data);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function create(_x, _x2) {
      return _ref2.apply(this, arguments);
    }

    return create;
  }()
};

/***/ }),
/* 103 */
/*!**********************************!*\
  !*** ./client/store/products.js ***!
  \**********************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__(/*! lodash.filter */ 104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderby__ = __webpack_require__(/*! lodash.orderby */ 55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_orderby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_orderby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_search__ = __webpack_require__(/*! mixins/search */ 105);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var state = {
  list: [],
  filter: {
    name: '',
    category: null
  },
  order: [{
    name: 'newest',
    field: 'created_at',
    direction: 'desc'
  }]
};

var getters = {
  products: function products(state) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(state.list, function (product) {
      return product.visible;
    });
  },
  filteredProducts: function filteredProducts(state, getters) {
    var products = getters.products;

    // filter products by category
    if (state.filter.category) {
      products = products.filter(function (product) {
        return product.categories.data && !!product.categories.data.find(function (productCategory) {
          return productCategory.id === state.filter.category;
        });
      });
    }

    // filter products by searchstring
    if (state.filter.name.length > 0) {
      products = __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(products, function (product) {
        return Object(__WEBPACK_IMPORTED_MODULE_4_mixins_search__["a" /* default */])(state.filter.name, [product.name]);
      });
    }

    // create a new virtual property that contains the price for sorting
    products = products.map(function (p) {
      return Object.assign({}, p, {
        sorting_price: p.use_discount_price ? p.default_discount_price : p.default_price
      });
    });

    return __WEBPACK_IMPORTED_MODULE_2_lodash_orderby___default()(products, state.order.map(function (item) {
      return item.field;
    }), state.order.map(function (item) {
      return item.direction;
    }));
  },
  countProducts: function countProducts(state) {
    return state.list.length;
  },
  countFilteredProducts: function countFilteredProducts(state, getters) {
    return getters.filteredProducts.length;
  },
  allSelected: function allSelected(state) {
    if (!state.list.length) return false;
    return state.list.reduce(function (acc, product) {
      return acc && product.isSelected;
    }, true);
  },
  hasSelected: function hasSelected(state) {
    if (!state.list.length) return false;
    return state.list.reduce(function (acc, product) {
      return acc || product.isSelected;
    }, false);
  },
  filterName: function filterName(state) {
    return state.filter.name;
  },
  filterCategory: function filterCategory(state) {
    return state.filter.category;
  },
  order: function order(state) {
    return state.order[0];
  },

  getProductById: function getProductById(state, getters) {
    return function (id) {
      if (state.list.length === 0) return null;
      return state.list.find(function (product) {
        return product.id === id;
      });
    };
  },
  getVariationForProduct: function getVariationForProduct(state, getters) {
    return function (productId, variationId) {
      var product = getters.getProductById(productId);
      if (!product || !product.variations) return null;

      return product.variations.data.find(function (variation) {
        return variation.id === variationId;
      });
    };
  }
};

var mutations = {
  add: function add(state, product) {
    var oldProduct = state.list.find(function (p) {
      return p.id === product.id;
    });

    if (oldProduct) {
      return state.list.splice(state.list.indexOf(oldProduct), 1, product);
    }

    return state.list.push(Object.assign({}, product, {
      isSelected: false
    }));
  },
  replace: function replace(state, product) {
    var oldProduct = state.list.find(function (p) {
      return p.id === product.id;
    });

    state.list.splice(state.list.indexOf(oldProduct), 1, Object.assign({}, product, {
      isSelected: oldProduct.isSelected
    }));
  },
  setFilterName: function setFilterName(state, search) {
    state.filter.name = search;
  },
  setFilterCategory: function setFilterCategory(state, category) {
    state.filter.category = category || undefined;
  },
  setOrder: function setOrder(state, order) {
    state.order = [order];
  },
  refreshStock: function refreshStock(state, stockUpdateObject) {
    var oldProduct = state.list.find(function (p) {
      return p.id === stockUpdateObject.id;
    });

    oldProduct.stock = stockUpdateObject.stock;
    oldProduct.use_stock = stockUpdateObject.use_stock;
  }
};

var actions = {
  request: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      var _ref3, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.list.length) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_plugins_axios__["a" /* default */].get('/product');

            case 4:
              _ref3 = _context.sent;
              data = _ref3.data;

              data.data.forEach(function (product) {
                return commit('add', product);
              });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function request(_x) {
      return _ref2.apply(this, arguments);
    }

    return request;
  }(),
  requestDetailed: function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, id) {
      var commit = _ref4.commit;

      var _ref6, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3_plugins_axios__["a" /* default */].get('/product/' + id + '?include=variations,options');

            case 2:
              _ref6 = _context2.sent;
              data = _ref6.data;

              commit('add', data.data);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function requestDetailed(_x2, _x3) {
      return _ref5.apply(this, arguments);
    }

    return requestDetailed;
  }(),
  refreshStock: function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(_ref7, id) {
      var commit = _ref7.commit;

      var _ref9, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3_plugins_axios__["a" /* default */].get('/product/' + id + '/stock');

            case 2:
              _ref9 = _context3.sent;
              data = _ref9.data;

              commit('refreshStock', data.data);

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function refreshStock(_x4, _x5) {
      return _ref8.apply(this, arguments);
    }

    return refreshStock;
  }(),
  setFilterCategory: function setFilterCategory(_ref10, category) {
    var commit = _ref10.commit;

    commit('setFilterCategory', category);
  }
};

/***/ }),
/* 104 */,
/* 105 */
/*!*********************************!*\
  !*** ./client/mixins/search.js ***!
  \*********************************/
/*! exports provided: default, searchByString */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchByString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_levenshtein__ = __webpack_require__(/*! fast-levenshtein */ 106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_levenshtein___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_levenshtein__);


var MAX_ALLOWED_DISTANCE = 3;

/* harmony default export */ __webpack_exports__["a"] = (function (searchString, fields) {
  return searchString.split(' ').reduce(function (carry, search) {
    return carry || searchByString(search, fields);
  }, false);
});

function searchByString(search, fields) {
  return fields.reduce(function (carry, field) {
    if (!search || !field) return false;
    var searchStr = search.toString().toLowerCase();
    var str = field.toString().toLowerCase();

    if (searchStr === '') return false;

    return carry || str.includes(searchStr) || __WEBPACK_IMPORTED_MODULE_0_fast_levenshtein___default.a.get(str, searchStr) <= MAX_ALLOWED_DISTANCE;
  }, false);
}

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/*!******************************!*\
  !*** ./client/store/shop.js ***!
  \******************************/
/*! exports provided: state, getters, mutations, actions */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return getters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutations", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_axios__ = __webpack_require__(/*! plugins/axios */ 5);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var state = {
  shop: null,
  meta: {
    useRootContainer: true,
    isMobile: false,
    isEditor: false
  }
};

var getters = {
  get: function get(state) {
    if (!state.shop) return {};
    return state.shop;
  },
  getMetaIsMobile: function getMetaIsMobile(state) {
    return state.meta.isMobile;
  },
  getMetaIsEditor: function getMetaIsEditor(state) {
    return state.meta.isEditor;
  },
  getUseRootContainer: function getUseRootContainer(state) {
    return state.meta.useRootContainer;
  }
};

var mutations = {
  set: function set(state, shop) {
    state.shop = shop;
  },
  setMetaIsMobile: function setMetaIsMobile(state, isMobile) {
    state.meta.isMobile = isMobile;
  },
  setMetaIsEditor: function setMetaIsEditor(state, isEditor) {
    state.meta.isEditor = isEditor;
  },
  setUseRootContainer: function setUseRootContainer(state, useRootContainer) {
    state.meta.useRootContainer = useRootContainer;
  }
};

var actions = {
  request: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      var _ref3, data;

      return __WEBPACK_IMPORTED_MODULE_0__var_www_wsc01_hosttech_eu_temp_1552556606_hosttechWscClient_modules_shop_gui_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!state.shop) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_plugins_axios__["a" /* default */].get('/shop');

            case 4:
              _ref3 = _context.sent;
              data = _ref3.data;

              commit('set', data.data);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function request(_x) {
      return _ref2.apply(this, arguments);
    }

    return request;
  }()
};

/***/ }),
/* 110 */
/*!*****************************************************!*\
  !*** ./client/router nonrecursive ^\.\/[^_].*\.js$ ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cart.js": 111,
	"./checkout.js": 116,
	"./conditions.js": 117,
	"./index.js": 21,
	"./products.js": 118
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;

/***/ }),
/* 111 */
/*!*******************************!*\
  !*** ./client/router/cart.js ***!
  \*******************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(/*! ./_helper */ 8);


/* harmony default export */ __webpack_exports__["default"] = ([Object.assign({
  path: '/cart'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('cart/index'))]);

/***/ }),
/* 112 */
/*!********************************************!*\
  !*** ./client/views/desktop lazy ^\.\/.*$ ***!
  \********************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cart": [
		10,
		3
	],
	"./cart/": [
		10,
		3
	],
	"./cart/index": [
		10,
		3
	],
	"./cart/index.vue": [
		10,
		3
	],
	"./cart/index/cart-article": [
		47,
		25
	],
	"./cart/index/cart-article.vue": [
		47,
		25
	],
	"./checkout": [
		11,
		5
	],
	"./checkout/": [
		11,
		5
	],
	"./checkout/completed": [
		56,
		31
	],
	"./checkout/completed.vue": [
		56,
		31
	],
	"./checkout/index": [
		11,
		5
	],
	"./checkout/index.vue": [
		11,
		5
	],
	"./checkout/index/cart-article": [
		48,
		24
	],
	"./checkout/index/cart-article.vue": [
		48,
		24
	],
	"./checkout/shipping": [
		57,
		21
	],
	"./checkout/shipping.vue": [
		57,
		21
	],
	"./conditions/business": [
		58,
		29
	],
	"./conditions/business.vue": [
		58,
		29
	],
	"./conditions/delivery": [
		59,
		27
	],
	"./conditions/delivery.vue": [
		59,
		27
	],
	"./products": [
		12,
		1
	],
	"./products/": [
		12,
		1
	],
	"./products/index": [
		12,
		1
	],
	"./products/index.vue": [
		12,
		1
	],
	"./products/index/listing-filter": [
		49,
		33
	],
	"./products/index/listing-filter.vue": [
		49,
		33
	],
	"./products/show": [
		60,
		6
	],
	"./products/show.vue": [
		60,
		6
	],
	"./products/show/view": [
		50,
		7
	],
	"./products/show/view.vue": [
		50,
		7
	],
	"./products/show/views/four": [
		42,
		13
	],
	"./products/show/views/four.vue": [
		42,
		13
	],
	"./products/show/views/one": [
		39,
		12
	],
	"./products/show/views/one.vue": [
		39,
		12
	],
	"./products/show/views/three": [
		41,
		11
	],
	"./products/show/views/three.vue": [
		41,
		11
	],
	"./products/show/views/two": [
		40,
		10
	],
	"./products/show/views/two.vue": [
		40,
		10
	],
	"./products/show/views/viewMixin": [
		36,
		17
	],
	"./products/show/views/viewMixin.js": [
		36,
		17
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 112;
module.exports = webpackAsyncContext;

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */
/*!*******************************************!*\
  !*** ./client/views/mobile lazy ^\.\/.*$ ***!
  \*******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cart": [
		13,
		2
	],
	"./cart/": [
		13,
		2
	],
	"./cart/index": [
		13,
		2
	],
	"./cart/index.vue": [
		13,
		2
	],
	"./cart/index/cart-article": [
		51,
		23
	],
	"./cart/index/cart-article.vue": [
		51,
		23
	],
	"./checkout": [
		14,
		4
	],
	"./checkout/": [
		14,
		4
	],
	"./checkout/completed": [
		61,
		30
	],
	"./checkout/completed.vue": [
		61,
		30
	],
	"./checkout/index": [
		14,
		4
	],
	"./checkout/index.vue": [
		14,
		4
	],
	"./checkout/index/cart-article": [
		52,
		22
	],
	"./checkout/index/cart-article.vue": [
		52,
		22
	],
	"./checkout/shipping": [
		62,
		20
	],
	"./checkout/shipping.vue": [
		62,
		20
	],
	"./conditions/business": [
		63,
		28
	],
	"./conditions/business.vue": [
		63,
		28
	],
	"./conditions/delivery": [
		64,
		26
	],
	"./conditions/delivery.vue": [
		64,
		26
	],
	"./products": [
		15,
		0
	],
	"./products/": [
		15,
		0
	],
	"./products/index": [
		15,
		0
	],
	"./products/index.vue": [
		15,
		0
	],
	"./products/index/listing-filter": [
		53,
		32
	],
	"./products/index/listing-filter.vue": [
		53,
		32
	],
	"./products/show": [
		65,
		8
	],
	"./products/show.vue": [
		65,
		8
	],
	"./products/show/view": [
		54,
		9
	],
	"./products/show/view.vue": [
		54,
		9
	],
	"./products/show/views/four": [
		46,
		18
	],
	"./products/show/views/four.vue": [
		46,
		18
	],
	"./products/show/views/one": [
		43,
		16
	],
	"./products/show/views/one.vue": [
		43,
		16
	],
	"./products/show/views/three": [
		45,
		15
	],
	"./products/show/views/three.vue": [
		45,
		15
	],
	"./products/show/views/two": [
		44,
		14
	],
	"./products/show/views/two.vue": [
		44,
		14
	],
	"./products/show/views/viewMixin": [
		37,
		19
	],
	"./products/show/views/viewMixin.js": [
		37,
		19
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 115;
module.exports = webpackAsyncContext;

/***/ }),
/* 116 */
/*!***********************************!*\
  !*** ./client/router/checkout.js ***!
  \***********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(/*! ./_helper */ 8);


/* harmony default export */ __webpack_exports__["default"] = ([Object.assign({
  path: '/checkout'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('checkout/index')), Object.assign({
  path: '/checkout/shipping'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('checkout/shipping')), Object.assign({
  path: '/checkout/checkout'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('checkout/checkout')), Object.assign({
  path: '/checkout/completed'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('checkout/completed'))]);

/***/ }),
/* 117 */
/*!*************************************!*\
  !*** ./client/router/conditions.js ***!
  \*************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(/*! ./_helper */ 8);


/* harmony default export */ __webpack_exports__["default"] = ([Object.assign({
  path: '/terms-and-conditions/business'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('conditions/business')), Object.assign({
  path: '/terms-and-conditions/delivery'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('conditions/delivery'))]);

/***/ }),
/* 118 */
/*!***********************************!*\
  !*** ./client/router/products.js ***!
  \***********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(/*! ./_helper */ 8);


/* harmony default export */ __webpack_exports__["default"] = ([Object.assign({
  path: '/products'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('products/index')), Object.assign({
  path: '/products/category/:category'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('products/index')), Object.assign({
  path: '/products/:id'
}, Object(__WEBPACK_IMPORTED_MODULE_0__helper__["a" /* componentsHelper */])('products/show'))]);

/***/ }),
/* 119 */
/*!*********************************!*\
  !*** ./client/plugins/index.js ***!
  \*********************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios__ = __webpack_require__(/*! ./axios */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uiv__ = __webpack_require__(/*! ./uiv */ 120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_components__ = __webpack_require__(/*! ./ui-components */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_i18n__ = __webpack_require__(/*! ./vue-i18n */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_paginate__ = __webpack_require__(/*! ./vue-paginate */ 152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wsc_shop__ = __webpack_require__(/*! ./wsc-shop */ 34);







/***/ }),
/* 120 */
/*!*******************************!*\
  !*** ./client/plugins/uiv.js ***!
  \*******************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uiv__ = __webpack_require__(/*! uiv */ 121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uiv__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tooltip', __WEBPACK_IMPORTED_MODULE_1_uiv__["Tooltip"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('carousel', __WEBPACK_IMPORTED_MODULE_1_uiv__["Carousel"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('slide', __WEBPACK_IMPORTED_MODULE_1_uiv__["Slide"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('collapse', __WEBPACK_IMPORTED_MODULE_1_uiv__["Collapse"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('dropdown', __WEBPACK_IMPORTED_MODULE_1_uiv__["Dropdown"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_1_uiv__["Modal"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tab', __WEBPACK_IMPORTED_MODULE_1_uiv__["Tab"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('tabs', __WEBPACK_IMPORTED_MODULE_1_uiv__["Tabs"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('datePicker', __WEBPACK_IMPORTED_MODULE_1_uiv__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('alert', __WEBPACK_IMPORTED_MODULE_1_uiv__["Alert"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('pagination', __WEBPACK_IMPORTED_MODULE_1_uiv__["Pagination"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('popover', __WEBPACK_IMPORTED_MODULE_1_uiv__["Popover"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('timePicker', __WEBPACK_IMPORTED_MODULE_1_uiv__["TimePicker"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('typeahead', __WEBPACK_IMPORTED_MODULE_1_uiv__["Typeahead"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('progressBar', __WEBPACK_IMPORTED_MODULE_1_uiv__["ProgressBar"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('progressBarStack', __WEBPACK_IMPORTED_MODULE_1_uiv__["ProgressBarStack"]);

/***/ }),
/* 121 */,
/* 122 */
/*!*****************************************!*\
  !*** ./client/plugins/ui-components.js ***!
  \*****************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ui_slider__ = __webpack_require__(/*! components/ui/slider */ 123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ui_loading__ = __webpack_require__(/*! components/ui/loading */ 126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ui_multiselect__ = __webpack_require__(/*! components/ui/multiselect */ 129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ui_singleselect__ = __webpack_require__(/*! components/ui/singleselect */ 133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ui_productPanel__ = __webpack_require__(/*! components/ui/productPanel */ 136);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ui-multiselect', __WEBPACK_IMPORTED_MODULE_3_components_ui_multiselect__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ui-singleselect', __WEBPACK_IMPORTED_MODULE_4_components_ui_singleselect__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ui-slider', __WEBPACK_IMPORTED_MODULE_1_components_ui_slider__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ui-loading', __WEBPACK_IMPORTED_MODULE_2_components_ui_loading__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('product-panel', __WEBPACK_IMPORTED_MODULE_5_components_ui_productPanel__["a" /* default */]);

/***/ }),
/* 123 */
/*!*****************************************!*\
  !*** ./client/components/ui/slider.vue ***!
  \*****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_vue__ = __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./slider.vue */ 27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2516a92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c2516a92","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./slider.vue */ 125);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c2516a92","scoped":false,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./slider.vue */ 124)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2516a92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 124 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c2516a92","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/ui/slider.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/*!******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2516a92","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/slider.vue ***!
  \******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch-checkbox"},[_c('div',{staticClass:"switch--switch"},[_c('label',{attrs:{"for":_vm.id}},[_c('input',{class:_vm.className,attrs:{"type":"checkbox","name":_vm.name,"id":_vm.id,"disabled":_vm.disabled,"required":_vm.required},domProps:{"value":_vm.value,"checked":_vm.value},on:{"change":_vm.updateInput}}),_vm._v(" "),_c('div',{staticClass:"slider round"})])]),_vm._v(" "),_c('div',{staticClass:"switch--label",domProps:{"innerHTML":_vm._s(_vm.label)},on:{"click":_vm.toggleChecked}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 126 */
/*!******************************************!*\
  !*** ./client/components/ui/loading.vue ***!
  \******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__ = __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./loading.vue */ 28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0efe1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5f0efe1e","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./loading.vue */ 128);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5f0efe1e","scoped":false,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./loading.vue */ 127)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0efe1e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 127 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f0efe1e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/ui/loading.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f0efe1e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/loading.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"wsc_loader--inline"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('span',{staticClass:"loader-label"},[_vm._v(_vm._s(_vm.$t('general.loading')))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 129 */
/*!**********************************************!*\
  !*** ./client/components/ui/multiselect.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multiselect_vue__ = __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./multiselect.vue */ 29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_163f9e9f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiselect_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-163f9e9f","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./multiselect.vue */ 132);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-163f9e9f","scoped":false,"hasInlineConfig":false}!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./multiselect.vue */ 130)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_multiselect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_163f9e9f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_multiselect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-163f9e9f","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/ui/multiselect.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */,
/* 132 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-163f9e9f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/multiselect.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{staticClass:"ui-multiselect",attrs:{"value":_vm.value,"label":_vm.label,"custom-label":_vm.customLabel,"track-by":_vm.trackBy,"options":_vm.options,"multiple":_vm.multiple,"taggable":_vm.taggable,"allow-empty":_vm.allowEmpty,"close-on-select":_vm.closeOnSelect,"clear-on-select":_vm.clearOnSelect,"disabled":_vm.disabled,"placeholder":_vm.placeholderText,"tag-placeholder":"","select-label":"","selected-label":"","deselect-label":""},on:{"tag":_vm.tag,"input":_vm.input}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('messages.filter-no-result')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/*!***********************************************!*\
  !*** ./client/components/ui/singleselect.vue ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_singleselect_vue__ = __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./singleselect.vue */ 30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61dcacbe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_singleselect_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-61dcacbe","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./singleselect.vue */ 135);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-61dcacbe","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./singleselect.vue */ 134)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61dcacbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_singleselect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61dcacbe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_singleselect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 134 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61dcacbe","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/ui/singleselect.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dcacbe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/singleselect.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{class:_vm.classes,attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"change":_vm.valueChanged}},[(_vm.placeholder)?_c('option',{attrs:{"disabled":""},domProps:{"value":undefined}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 136 */
/*!***********************************************!*\
  !*** ./client/components/ui/productPanel.vue ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productPanel_vue__ = __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./productPanel.vue */ 31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5886179e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productPanel_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5886179e","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./productPanel.vue */ 137);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5886179e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 137 */
/*!************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5886179e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/productPanel.vue ***!
  \************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'product--show-panel': _vm.usePanels, 'product--hide-panel': !_vm.usePanels}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/*!************************************************!*\
  !*** ./client/plugins/i18n-formaters/price.js ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store__ = __webpack_require__(/*! store */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plugins_wsc_shop__ = __webpack_require__(/*! plugins/wsc-shop */ 34);



var price = function price(value) {
  if (!__WEBPACK_IMPORTED_MODULE_0_store__["default"].state.shop.shop) return '';

  var shopCurrency = __WEBPACK_IMPORTED_MODULE_1_plugins_wsc_shop__["a" /* supportedCurrencies */].find(function (option) {
    return option.value === __WEBPACK_IMPORTED_MODULE_0_store__["default"].state.shop.shop.currency;
  });

  // divide the value by 100 to convert from cent to currency
  var formatedPrice = (value / 100).toLocaleString(shopCurrency.local, {
    minimumFractionDigits: 2
  });

  if (shopCurrency) {
    return shopCurrency.short + ' ' + formatedPrice;
  }
  return formatedPrice;
};

/* harmony default export */ __webpack_exports__["a"] = (price);

/***/ }),
/* 151 */
/*!***********************************!*\
  !*** ./static/locales/de-DE.json ***!
  \***********************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

module.exports = {"cart":{"add-this-to-cart":"In den Warenkorb legen","variation-not-available":"Variante nicht verfügbar","add-to-cart":"In den Warenkorb","added-to-cart":"{n, plural, one{Das Produkt wurde} other{Die Produkte wurden}} erfolgreich zum Warenkorb hinzugefügt.","adding-to-cart":"Wird hinzugefügt","article":"Artikel","cart-not-available-in-editor":"Der Warenkorb ist im Editor nicht verfügbar.","count":"Anzahl","my-cart":"Warenkorb","remove-article":"Artikel entfernen","shipping":"Versandkosten","subtotal":"Zwischensumme","total":"Total","variation":"Variante","variations":"Varianten","vat":"MwSt"},"checkout":{"billing-address":"Rechnungsadresse","checkout":"Kasse","comment":"Bemerkungen","comment-help":"Bemerkungen zur Bestellung","complete":"Bestellung abgeschlossen","customer-data":"Kundendaten","delivery-address":"Lieferadresse","delivery-and-payment":"Versand und Zahlungsmethode","delivery-type":"Versandart","form":{"address":"Adresse","city":"Ort","company":"Firma","country":"Land","email":"E-Mail","firstname":"Vorname","lastname":"Name","phone":"Telefon","title":"Anrede","zip":"PLZ"},"my-order":"Meine Bestellung","payment-and-delivery-type":"Versand und Zahlungsmethode","payment-method":"Zahlungsmethode","payment-methods":{"bill":"Kauf auf Rechnung","cash-on-delivery":"Per Nachnahme","prepay":"Vorauskasse","stripe":"Kreditkarte","paypal":"PayPal"}},"conditions":{"business":"Allgemeine Geschäftsbedingungen","delivery":"Versandbedingungen"},"filters":{"categories":"Kategorie","order":"Sortieren","order-by":{"availability":"Verfügbarkeit","cheapest":"Günstigste","expensive":"Teuerste","name":"Name","newest":"Neuste"},"search":"Produkt suchen"},"format":{"price":"{price, price}"},"general":{"back-to-cart":"Zurück zum Warenkorb","back-to-customer":"Zurück zu Kundendaten","back-to-shop":"Zurück zum Shop","cancel":"Abbrechen","ok":"Ok","pay-with-stripe":"Mit Kreditkarte bezahlen","send-order":"Bestellen","to-cart":"Zum Warenkorb","to-checkout":"Zur Kasse","prices-starting-at":"ab"},"messages":{"cart-discount-calculation":"Versand und MwSt. werden beim Zahlungsvorgang berechnet.","checkout-complete":"Herzlichen Dank für Ihre Bestellung!<br>Sie erhalten in den nächsten Minuten eine E-Mail mit der Bestätigung.","loading-cart-content":"Warenkorb wird geladen...","no-cart-content":"Es befinden sich noch keine Artikel im Warenkorb","same-delivery-address":"Gleich wie Rechnungsadresse","different-delivery-address":"Alternative Lieferadresse erfassen","filter-no-result":"Keine Ergebnisse gefunden","error-while-processing-payment":"Beim Verarbeiten der Zahlung ist ein Fehler aufgetreten. Bitte prüffen Sie ihre Eingabe."},"products":{"article_number":"Artikelnr.","categories":"Kategorien","category":"Kategorie","description":"Beschreibung","discount_price":"Aktionspreis","filter-reset":"Filter zurücksetzen","in-stock":"Auf Lager","just-few-in-stock":"Weniger als 10 Stück auf Lager","name":"Name","options":"Produktoptionen","out-of-stock":"Nicht auf Lager","price":"Preis","search-products-count":"<b>{n}</b> Artikel gefunden","stock":"Bestand","variations":"Varianten","visibility":"Sichtbarkeit","visible":"Produkt ist sichtbar","weight":"Gewicht"}}

/***/ }),
/* 152 */
/*!****************************************!*\
  !*** ./client/plugins/vue-paginate.js ***!
  \****************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_paginate__ = __webpack_require__(/*! vue-paginate */ 153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_paginate__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_paginate___default.a);

/***/ }),
/* 153 */,
/* 154 */
/*!********************************!*\
  !*** ./assets/scss/style.scss ***!
  \********************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[66]);


// WEBPACK FOOTER //
// client.841f08ee.js